/**
 * Recupero password (V02): si chiede il link di reimpostazione.
 *
 * La risposta e la stessa per ogni email, registrata o no: la pagina conferma
 * sempre allo stesso modo e non dice se un'email partira davvero.
 */

import { type FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { chiama } from '../api/client.js';
import './accesso.css';

export function PaginaRecupero() {
  const [email, setEmail] = useState('');
  const [invio, setInvio] = useState(false);
  const [inviata, setInviata] = useState(false);
  const [errore, setErrore] = useState<string | null>(null);

  const invia = async (e: FormEvent) => {
    e.preventDefault();
    setInvio(true);
    setErrore(null);
    try {
      await chiama('/password-dimenticata', { metodo: 'POST', corpo: { email } });
      setInviata(true);
    } catch {
      setErrore("Richiesta non riuscita. Controlla l'email e riprova.");
    } finally {
      setInvio(false);
    }
  };

  return (
    <div className="accesso">
      <form className="accesso-scheda" onSubmit={(e) => void invia(e)}>
        <h1>Password dimenticata</h1>

        {inviata ? (
          <>
            <p>
              Se <strong>{email}</strong> è l'email di un account, tra poco arriva un messaggio con
              il link per scegliere una nuova password.
            </p>
            <p className="accesso-nota">
              Il link vale un'ora. Se non arriva, controlla la posta indesiderata o riprova tra
              qualche minuto.
            </p>
          </>
        ) : (
          <>
            <p className="accesso-nota">
              Scrivi l'email con cui accedi: ti mandiamo il link per scegliere una nuova password.
            </p>

            {errore && (
              <div className="banda" role="alert">
                {errore}
              </div>
            )}

            <label className="campo">
              Email
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                required
              />
            </label>

            <button type="submit" disabled={invio}>
              {invio ? 'Invio in corso…' : 'Invia il link'}
            </button>
          </>
        )}

        <Link to="/accesso" className="accesso-link">
          Torna all'accesso
        </Link>
      </form>
    </div>
  );
}
